import React from "react";
import NewsletterOne from "../component/NewsletterOne";

function NewsletterOneContainers() {
  return <NewsletterOne />;
}

export default NewsletterOneContainers;
